const EnLang = {
  TRANSACTIONS: "Transactions",
  LOGOUT: "Logout",
  EMAIL: "Email",
  PHONE: "Phone",
};

export default EnLang;
